module.exports = __webpack_public_path__ + "static/media/close-circle-blue.7a3bfc0b.svg";